module.exports = __webpack_public_path__ + "static/media/woop-woop.541a7caa.mp3";